import { Coins, Gift, Layers, ListChecks, Users } from "lucide-react";
import type { SideTab } from "@/components/shared";
import { IncomeEntriesReport } from "@/components/reports";
import { useIncomeEntries } from "@/hooks/queries";

/** My income reports. Add an entry to give it a tab and a URL (/account/reports/<id>). */
export const accountReports: SideTab[] = [
  {
    id: "all",
    label: "All Summary",
    group: "Income",
    icon: ListChecks,
    render: () => (
      <IncomeEntriesReport
        kind="all"
        title="All Summary"
        description="All cashback and referral income transactions combined."
        useEntries={useIncomeEntries}
      />
    ),
  },
  {
    id: "direct",
    label: "Direct Income",
    group: "Income",
    icon: Users,
    render: () => (
      <IncomeEntriesReport
        kind="direct"
        title="Direct Income"
        description="Referral cashback earned from Level 1 direct team members."
        useEntries={useIncomeEntries}
      />
    ),
  },
  {
    id: "level",
    label: "Level Income",
    group: "Income",
    icon: Layers,
    render: () => (
      <IncomeEntriesReport
        kind="level"
        title="Level Income"
        description="Referral cashback from your referral downline (all levels)."
        useEntries={useIncomeEntries}
      />
    ),
  },
  {
    id: "reward",
    label: "Reward Income",
    group: "Income",
    icon: Gift,
    render: () => (
      <IncomeEntriesReport
        kind="reward"
        title="Reward Income"
        description="Reward cashback earned from claiming Rank Reward milestones."
        useEntries={useIncomeEntries}
      />
    ),
  },
  {
    id: "cashback",
    label: "Cashback Income",
    group: "Income",
    icon: Coins,
    render: () => (
      <IncomeEntriesReport
        kind="cashback"
        title="Cashback Income"
        description="Cashback earned from self purchases and active member bonuses."
        useEntries={useIncomeEntries}
      />
    ),
  },
];
